import React, { useEffect, useState, useCallback ,useRef } from "react";
import AddIcon from "@mui/icons-material/Add";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Filter from "../filter/filter";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import checkImage from "../../assests/images/check-circle.png";
import SwapVertIcon from '@mui/icons-material/SwapVert';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { projectServices } from "../../services/projectServices";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import _ from "lodash";
import AlertComponent from "../alert/alert";
import { Backdrop, CircularProgress } from "@mui/material";
import BulkUploadModal from "../common/bulkUpload";
import { getSecPermission, isEmptyDash, strToDate,trimString } from "../../constant";
import sampleProjectFile from "../../assests/document/bulk_project_temp.xlsx";
import { usePreviousLocation } from "../../components/withSidebar/PreviousLocationContext";
import { UserObj } from "../../services/localStarage";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png'; 
import { onboardingServices } from "../../services/onboardingServices";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Tooltip from '@mui/material/Tooltip'; 
import DownloadIcon from '@mui/icons-material/Download';
import { downloadFile } from "../buyerPurchaseOrder/index.js"; 
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";  

const initialColumns = [
  { id: "projectName", label: "Project Name", isSort: true, sortLabel: "", isFiltered: false },
  { id: "capacity", label: "Capacity", isSort: true, sortLabel: "", isFiltered: false },
  { id: "projectCode", label: "Project Code", isSort: true, sortLabel: "", isFiltered: false },
  { id: "projectLocation", label: "Project Location", isSort: true, sortLabel: "", isFiltered: false },
  { id: "noOfPackages", label: "No. of Packages", isSort: true, sortLabel: "", isFiltered: false },
  { id: "COD", label: "COD", isSort: true, sortLabel: "", isFiltered: false },
  { id: "createdBy", label: "Created by", isSort: true, sortLabel: "", isFiltered: false },
  { id: "updatedAt", label: "last updated on", isSort: true, sortLabel: "", isFiltered: false },
  { id: "creationDate", label: "Creation Date", isSort: true, sortLabel: "", isFiltered: false },
  { id: "status", label: "Status", isSort: true, sortLabel: "", isFiltered: false },
  // { id: "col10", label: "Remarks", isSort: false, sortLabel: "asc" },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const filterprojectlistingstyle = {
  position: "absolute",
  top: "40%",
  left: "40%",
  transform: "translate(-50%, -50%)",
  width: "40%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};


const createTableArr1 = [
  { label: "Project Name", name: "projectName", value: "", options: [], errMsg: "" },
  { label: "COD", name: "COD", value: "", options: [], errMsg: "" },
  { label: "Location", name: "location", value: "", options: [], errMsg: "" },
  { label: "Capacity", name: "capacity", value: "", options: [], errMsg: "" },
];


function ProjectListing() {
  const [columns, setColumns] = useState(initialColumns);
  const [formData, setFormData] = useState({
    projectName: '',
    location: '',
    capacity: '',
   // COD: ''
  });
  const [alertComponent, setAlertComponent] = useState({
    open: false,
    message: "",
    type: "",
  });
  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };

  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [projectCode, setProjectCode] = useState('');
  const [opencreateprojectslisting, setOpenCreateProjectsListing] =
    useState(false);
  const [opencreateprojectsuccessfully, setOpenCreateProjectSuccessfully] =
    useState(false);
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [secPermission, setSecPermission] = useState({
    "create": false,
    "read": false,
    "update": false,
    "delete": false
  });
  const [projectCreationlist, setProjectCreationlist] = React.useState({
    totalPages: 0,
    currentPage: 1,
    totalItems: 0,
    projects: [],
  });
  const [openBulkUploadModal, setOpenBulkUploadModal] = React.useState(false);
  const [openDefaulfFields, setOpenDefaulfFields] = React.useState(false);
  const [createTableArr, setCreateTableArr] = useState(createTableArr1);
  const [filterText, setFilterText] = useState("");

  const [filterFormData, setFilterFormData] = useState("");

  const [isEdited, setIsEdited] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [inputPage, setInputPage] = useState(projectCreationlist?.currentPage || 1);
  const [secCreatePermission, setCreatePermission] = useState({
    "create": false,
    "read": false,
    "update": false,
    "delete": false
  });
  // const handleChange = (e) => {
  //   setFormData({ ...formData, [e.target.id]: e.target.value });
  // };
  const fileInputRef = useRef([]);
  const [isFilterTabOpen, setIsFilterTabOpen] = useState(false);
  const userRole = UserObj?.role?.name;
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };

  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const pageNumber = parseInt(inputPage, 10);
      if (pageNumber >= 1 && pageNumber <= projectCreationlist?.totalPages) {
        onPaginationChange(null, pageNumber);
      }
    }
  };


  const handleChange = (e) => { 
    const { name, value } = e.target;
    let updatedValue = value; 
    setIsEdited(true);
  
    // // Handling specific fields with custom validation or transformation
    // if (id === 'location') {
    //   // updatedValue = value.replace(/[^a-zA-Z\s]/g, ''); // Uncomment for location-specific validation
    // }
    // if (id === 'projectName') {
    //   // updatedValue = value.replace(/[^a-zA-Z0-9\s]/g, ''); // Uncomment for projectName-specific validation
    // }
    // if (id === 'capacity') {
    //   updatedValue = value.replace(/[^a-zA-Z0-9\s]/g, ''); // Capacity-specific validation
    // }
  
    if (name === "COD") {
      const dateParts = value.split("-");
      if (dateParts.length === 3) {
        const year = dateParts[0];
        if (year.length <= 4 && /^[0-9]{0,4}$/.test(year)) {
          updatedValue = value;
        } else {
          return; // Invalid year, do nothing
        }
      }
    }
  
    // Update the form data with the new value for the correct input field
    setFormData((prevData) => ({
      ...prevData,
      [name]: updatedValue,  
    }));
  
    // Clear the error message for the specific field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '', // Clear any existing errors for this field
    }));
  };

  const handleClose = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };
 const [activeProjectFields, setactiveProjectFields] = useState([]);
  // const validateForm = () => {
  //   const newErrors = {};
  //   if (!formData.projectName) newErrors.projectName = 'Project Name is required';
  //   if (!formData.location) newErrors.location = 'Project Location is required';
  //   if (!formData.capacity) newErrors.capacity = 'Capacity is required';
  //   if (!formData.COD) newErrors.COD = 'Calendar Date is required';
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };
  const validateForm = () => {
      const newErrors = {}; 
        Object.values(activeProjectFields).forEach(field => {
          if (field.display && field.required) {
              const fieldValue = formData[field.uniqueName];
              if (!fieldValue) {
                  newErrors[field.uniqueName] = `${field.name} is required`;
              }
          }
      }); 
      if (!formData.projectName) {
        newErrors.projectName = 'Project Name is required';
    }
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return; 
      // Prepare additionalFields to include only dynamic fields (static: false) 
      const additionalFields = Object.keys(formData)
      .filter((key) => Array.isArray(activeProjectFields) && activeProjectFields.find((field) => field.uniqueName === key && !field.static))  // Only dynamic fields
      .reduce((obj, key) => {
        obj[key] = formData[key];
        return obj;
      }, {});
  
    // Remove dynamic fields from the original formData
    const filteredFormData = Object.keys(formData)
      .filter((key) => Array.isArray(activeProjectFields) && !activeProjectFields.find((field) => field.uniqueName === key && !field.static))  // Only static fields
      .reduce((obj, key) => {
        obj[key] = formData[key];
        return obj;
      }, {}); 
    const dataToSubmit = {
      ...filteredFormData,  // Only static fields here
      additionalFields: additionalFields,  // Only dynamic fields inside additionalFields
    };   
    setIsLoading(true);
    projectServices
      .addNewProject(dataToSubmit)
      .then((res) => {
        setProjectCode(res?.data?.data?.projectCode);
        setOpenCreateProjectsListing(false);
        setOpenCreateProjectSuccessfully(true);
        setFormData({
          projectName: '',
          location: '',
          capacity: '',
          COD: ''
        });
          window.location.reload();
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message}`,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedColumns = Array.from(columns);
    const [removed] = reorderedColumns.splice(result.source.index, 1);
    reorderedColumns.splice(result.destination.index, 0, removed);

    setColumns(reorderedColumns);
  };

  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };
  const [activeFilters, setActiveFilters] = useState([]);
  const handleFilterFormSubmit = (formDataa) => {
    setFilterFormData(formDataa);
    const updatedPayload = {
      ...requestPayload,
      searchCriteria: formDataa,
    };
    setRequestPayload(updatedPayload);
    getProjectListing(updatedPayload, filterText, formDataa || '');
    const updatedColumns = columns.map((col) => {
      const isFiltered = Object.keys(formDataa).includes(col.id);
      return { ...col, isFiltered };
    });
    setColumns(updatedColumns);

    const filters = Object.keys(formDataa).map((key) => {
      if (key.endsWith('_from_date') || key.endsWith('_to_date')) {
        const fieldBaseName = key.replace('_from_date', '').replace('_to_date', '');
        return `${fieldBaseName}: ${formDataa[key.replace('_from_date', '') + '_from_date'] || ''} to ${formDataa[key.replace('_from_date', '') + '_to_date'] || ''}`;
      }
      return `${key}:${formDataa[key]}`;
    });
    setActiveFilters(filters);
  };



  const handleResetFormSubmit = () => {
    getProjectListing(requestPayload, filterText, {});
    const resetColumn = columns.map(col => ({
      ...col, isFiltered: false,
    }))
    setColumns(resetColumn);
    setActiveFilters([]);
    setFilterFormData({});
  }


  useEffect(() => {
    let permissionObj = getSecPermission("PROJECT_LISTING");
    let permissionCreateObj = getSecPermission("CREATE_PROJECT");
    setCreatePermission(permissionCreateObj);
    setSecPermission(permissionObj);

    if (previousLocation?.pathname?.includes("/admin/Project-Manager-Detail")) {
      const UserObjInit = JSON.parse(sessionStorage.getItem('user'));
      if (UserObjInit.prevLocationData.componentName == "PROJECT_LISTING") {
        setFilterText(UserObjInit.prevLocationData?.filterText);
        setRequestPayload(UserObjInit.prevLocationData?.requestPayload);
        setFilterFormData(UserObjInit.prevLocationData?.filterFormData);
      }
    }

  }, []);

  useEffect(() => {
    getProjectListing(requestPayload, filterText, filterFormData);
  }, [requestPayload]);

  const getProjectListing = (requestPayloadParam, filterTextParam, formData) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${filterTextParam}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    const filteredFormData = formData ? Object.entries(formData)
      .filter(([key, value]) => value !== '')
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {}) : {};
    if (filteredFormData && Object.keys(filteredFormData).length > 0) {
      Object.entries(filteredFormData).forEach(([key, value]) => {
        param += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
      });
    }
    projectServices
      .getProjectListing(param)
      .then((res) => {
        if (res.data.success === true) {
          setProjectCreationlist(res.data.data);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message} `,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
  }

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayload(requestPayloadInit);
  }

  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);
    }, 800),
    []
  );

  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value);
    debouncedSearch(value);
  };

  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };

  const onFilterSubmit = () => {
    getProjectListing(requestPayload, filterText);
  };

  const onSortChange = (index, sortBy, sortOrder) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    let columnsInit = _.cloneDeep(columns);
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
    requestPayloadInit.sortArray = [sortBy, newSortLael];
    requestPayloadInit.pageNumber = 1;
    columnsInit[index].sortLabel = newSortLael;
    setRequestPayload(requestPayloadInit);
    setColumns(columnsInit);
  }

  const onsetOpenDefaulfFields = (param) => {
    setOpenDefaulfFields(param);
  };

  const onBulkUploadSubmit = (fileDataParam, createTableArr) => {

    let isValid = true;
    for (let i = 0; i < createTableArr.length; i++) {
      if (isEmptyDash(createTableArr[i].value)) {
        createTableArr[i].errMsg = `Please fill this required field.`;
        isValid = false;
      } else {
        createTableArr[i].errMsg = ``;
      }
    }
    if (isValid) {
      let dataArr = [];
      for (let i = 0; i < createTableArr.length; i++) {
        let obj = {
          excelColumn: createTableArr[i].value,
          field: createTableArr[i].name,
        };
        dataArr.push(obj);
      }
      let formData = new FormData();
      formData.append("file", fileDataParam);
      formData.append("columnMappings", JSON.stringify(dataArr));

      setIsLoading(true);
      projectServices
        .createBulkProject(formData)
        .then((res) => {
          openAlert(true, "success", res?.data?.message);
          getProjectListing(requestPayloadInitials, filterText);
          setOpenDefaulfFields(false);
        })
        .catch(function (error) {
          openAlert(true, "error", `${error?.response?.data?.message} `);
        })
        .finally((param) => {
          setIsLoading(false);
        });
    } else {
      setCreateTableArr(createTableArr);
      openAlert(true, "error", `Please fill all mandatory fields.`);
    }
  };
  const clearProjectFormData = () => {
    setFormData({
      projectName: '',
      location: '',
      capacity: '',
      COD: ''
    });
    setErrors('');
  }

  const handleProjectClose = () => {
    if (isEdited) {
      setShowConfirmation(true);
    } else {
      setOpenCreateProjectsListing(false);
      setFormData({
        projectName: '',
        location: '',
        capacity: '',
        COD: ''
      });
      setErrors('');
      setIsEdited(false);
    }
  }
  const handleConfirmationResponse = (confirm) => {
    if (confirm) {
      setOpenCreateProjectsListing(false);
      setFormData({
        projectName: '',
        location: '',
        capacity: '',
        COD: ''
      });
      setErrors('');
      setIsEdited(false);
    }
    setShowConfirmation(false);
  };

  const handleRemoveFilter = (filterIndex, valueToRemove) => {
    // Splitting the label and values of the target filter
    const [targetLabel, targetValues] = activeFilters[filterIndex].split(':');
    const valuesArray = targetValues.split(',');

    // Removing the value to be removed
    const updatedValues = valuesArray.filter(val => val.trim() !== valueToRemove);

    let updatedFilters = [...activeFilters];

    // If no values remain, remove the entire filter
    if (updatedValues.length === 0) {
      updatedFilters = updatedFilters.filter((_, i) => i !== filterIndex);
    } else {
      // Update the target filter with remaining values
      updatedFilters[filterIndex] = `${targetLabel}:${updatedValues.join(',')}`;
    }

    setActiveFilters(updatedFilters);

    // Prepare the updated form data
    const updatedFormData = { ...filterFormData };
    if (!updatedValues.length) {
      // Remove the key entirely if no values remain
      delete updatedFormData[targetLabel];
    } else {
      // Update the form data with remaining values
      updatedFormData[targetLabel] = updatedValues.join(',');
    }

    handleFilterFormSubmit(updatedFormData);
  };
  const formatLabel = (label) => {
    const formattedLabel = label.replace(/([A-Z])/g, ' $1').trim();
    return formattedLabel.charAt(0).toUpperCase() + formattedLabel.slice(1);
  };
  const previousLocation = usePreviousLocation();
  let navigate = useNavigate();
  const navigateUrl = (param) => {
    navigate(param);
  };
  const redirectToDetails = (redirectId) => {
    const UserObjInit = JSON.parse(sessionStorage.getItem('user'));
    let param = {
      requestPayload: requestPayload,
      filterText: filterText,
      filterFormData: filterFormData,
      componentName: "PROJECT_LISTING",
    };
    UserObjInit["prevLocationData"] = param;
    sessionStorage.setItem("user", JSON.stringify(UserObjInit));
    navigateUrl(`/admin/Project-Manager-Detail/${redirectId}`);
  };

  const handleFilterButtonClick = () => {
    const filterButton = document.querySelector('.filter_box');
    if (filterButton) {
      const clickableElement = filterButton.querySelector('button') || filterButton;
      clickableElement.click();
    } else {
      console.error('No element found with class filter_box');
    }
  };
  const today = new Date().toISOString().split('T')[0];
  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() + 5);
  const maxDateStr = maxDate.toISOString().split('T')[0];
 

  useEffect(() => {
    getProjectFieldDetails();
  }, []);

  const getProjectFieldDetails = () => {
    setIsLoading(true); 
    projectServices
      .getProjectFieldList('BIDDING','PROJECT')
      .then((res) => { 
        const fields = res?.data?.data?.sections?.[0]?.fields || [];
        if (fields.length > 0) {
          setactiveProjectFields(fields);  
        } else {
          setAlertComponent({
            open: true,
            type: "info",  
            message: "No Data Available",
          });
        }
      })
      .catch(function (error) {
        // setAlertComponent({
        //   open: true,
        //   type: "error",
        //   message: `${error?.response?.data?.message} `,
        // });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }; 

  const uploadFile = (e, document, index) => { 
    e.preventDefault();
    let formData = new FormData();
    let files = e.target.files[0]
    const documentName = e.target?.dataset?.documentname;
    const uniqueName = e.target?.dataset?.uniquename;
    formData.append("file", e.target.files[0]);
    setIsLoading(true);
    onboardingServices
      .uploadFile(formData)
      .then(function (response) {
        if (response?.data?.success === true) {
          setUrl(response?.data?.data, files, document, index);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message}`);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  const encodeKey = (key) => {
    if (!key) return key;
    return encodeURIComponent(key);
  };
  const[activeDocument, setActiveDocument] = useState('');
  
 const setUrl = (data, files, document, index) => {
  // Clone the current state to avoid direct mutation
  let filterFormDataCopy = _.cloneDeep(filterFormData); 

  // Check and update the relevant document field
  if (filterFormDataCopy?.fields?.length) {
    for (let i = 0; i < filterFormDataCopy.fields.length; i++) {
      if (filterFormDataCopy.fields[i]?.uniqueName === document) {
        filterFormDataCopy.fields[i].response =
          filterFormDataCopy.fields[i].response || [];
        let fileObj = {
          key: encodeKey(data?.data?.Key),
          fileName: files?.name,
        };
        filterFormDataCopy.fields[i].response.push(fileObj);
      }
    }
  } else {
    console.warn("No fields found to update.");
  }

  // Update the state with the modified copy
  setFilterFormData(filterFormDataCopy);
};

const handleButtonClick = (i) => { 
  fileInputRef.current[i].click();
};

 const [downloadEl, setdownloadEl] = React.useState(null);
  const [confirmObj, setConfirmObj] = useState({});
  const [openheaderlevelexcelmodal, setOpenHeaderLevelExcelModal] =
  useState(false);
  const [openheaderlevelsucessfullymodal, setOpenHeaderLevelSucessfullyModal] =
      useState(false);
  const download = Boolean(downloadEl);
  const handleClicks = (event) => {
    setdownloadEl(event.currentTarget);
  };
  const handleCloses = () => {
    setdownloadEl(null);
  };

  const openConfirmModal = (param) => { 
    let obj = {};
    obj["id"] = param;
    if (param == "header") {
      obj["text"] = "Header Level Excel";
    }
    if (param == "line-item") {
      obj["text"] = "Line Item Level Excel";
    } 
    setConfirmObj(obj);
    setOpenHeaderLevelExcelModal(true);
  }
  const closeConfirmModal = (param) => {
    setConfirmObj({});
    setOpenHeaderLevelExcelModal(false);
  }

  const downloadProject = () => {
    setIsLoading(true);
    let bodyData = { 
      "type": confirmObj?.id, // "line-item", header,
      ...filterFormData
    };

    if (!isEmptyDash(filterText)) {
      bodyData["search"] = filterText;
    }

    let fileName = "";  
    if (confirmObj?.id == "header") {
      fileName = "Project_Header_Level_Excel.xlsx";
    }
    if (confirmObj?.id == "line-item") {
      fileName = "Project_Line_Item_Level_Excel.xlsx";
    } 
    
    const data = {
      url: `/v1/internal/projects/download`,
      bodyData: bodyData,
      method: "POST",
      fileName: fileName
    };
    downloadFile(data)
      .then(response => {
        if (isEmptyDash(response)) {
          setOpenHeaderLevelExcelModal(false);
          setOpenHeaderLevelSucessfullyModal(true);          
        } else {        
          setAlertComponent({ open: true, type: "success", message: `${response?.data?.message}` });          
        }
      })
      .catch(error => {
        setAlertComponent({ open: true, type: "error", message: `There is some error to download file. ` });
      })
      .finally(() => {
        setIsLoading(false);
        setOpenHeaderLevelExcelModal(false);
      })

  }
  return (
    <>
      <div className="login-forms">
        <div className="text-centers row_purchase_invoice_dragdropcontext_apps_body">
          <div>
            <div className="search_filter_outerse ms-auto">
              <div className="search_main">
                <h5>Project Listing </h5>
              </div>
            </div>
            <div className="search_filter_outers ms-auto">
              <div className="search_main">
                <div id="custom-search-input">
                  <div className="input-group col-md-12">
                    <input
                      type="text"
                      className="form-control input-lg"
                      placeholder="Search here"
                      fdprocessedid="8achb"

                      onChange={onFilterTextChange}
                      value={filterText}
                      onKeyPress={onKeyPressHandler}
                    />
                    <span className="input-group-btn">
                      <button
                        className="btn btn-info btn-lg"
                        type="button"
                        fdprocessedid="trsp06"
                      >
                        <span className="glyphicon glyphicon-search">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-search"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                          </svg>
                        </span>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div className="create_listing_project">
              <button
                    // onClick={() => { openConfirmModal() }}
                    style={{ backgroundColor: "#274594" }} 
                    className="gate_btn_lr_creations_1 vendor_maine_contents"
                    id="basic-button"
                    aria-controls={download ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={download ? "true" : undefined} 
                    onClick={handleClicks}
                  >
                    <DownloadIcon />
                    Download
                  </button>
                  <Menu
                    id="basic-menu"
                    anchorEl={downloadEl}
                    open={download}
                    onClose={handleCloses}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  > 
                    <MenuItem onClick={() => openConfirmModal("header")}>
                     Header Level Excel
                    </MenuItem> 
                    <MenuItem onClick={() => openConfirmModal("line-item")}>
                      Line Item Level Excel
                    </MenuItem>
                  </Menu>


                {(secCreatePermission?.read === true) && <div className="vendor_listing_lr_block_body">
                  <button
                    onClick={() => {
                      setOpenCreateProjectsListing(true);
                    }}
                    className="gate_btn_lr_creations"
                  >
                    <AddIcon />
                    Create Projects
                  </button>
                  <Button
                    className="vendor_btn"
                    variant="contained"
                    color="success"
                    onClick={() => setOpenBulkUploadModal(true)}
                  >
                    Import
                  </Button>
                </div>}

                <div className="row_filterrbtnvendor_box">
                  <div className="lets_filter_vendorlist_body_detail filter_box" id="">
                    <FilterAltOutlinedIcon />
                    <Filter uniqueName="PROJECTS" formSubmitFunction={handleFilterFormSubmit} resetFilter={handleResetFormSubmit} handleViewFilter={setIsFilterTabOpen} />
                  </div>

                  <Backdrop
                    sx={{
                      color: "#fff",
                      zIndex: (theme) => theme.zIndex.drawer + 1,
                    }}
                    open={isLoading}
                  >
                    <CircularProgress color="inherit" />
                  </Backdrop>
                </div>
              </div>
            </div>
            <div>
              <ul className="project_listing_gap_bcfe_react">
                {activeFilters.slice(0, 3).map((filter, index) => {
                  const [label, value] = filter.split(':');
                  const valuesArray = value.split(',');
                  return (
                    <li key={index} className="project_listing_gap_bcfe_react_one">
                      <strong>{formatLabel(label)}:</strong>
                      {valuesArray.map((val, i) => (
                        <span key={i} className="filter_sel">
                          {val}
                          <button
                            type="button"
                            className="btn-close"
                            style={{ fontSize: "10px", marginLeft: "5px" }}
                            onClick={() => handleRemoveFilter(index, val)}
                          ></button>
                        </span>
                      ))}
                    </li>
                  );
                })}
                {activeFilters.length > 3 && (
                  <button className="btn btn-outline-info" onClick={handleFilterButtonClick}><AddIcon className="add_icons" />{activeFilters.length}</button>
                )}
              </ul>

            </div>
          </div>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable" direction="horizontal">
              {(provided) => (
                <div style={{ width: "100%", overflow: "hidden" }}
                  className="listing_main listing_main_dragdropcontext_body listingmain"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  <table className="dragdropcontext_ondragend_block_row">
                    <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                      <tr>
                        <th className="vendor_tabels">
                          {/* <input type="checkbox" /> */}
                        </th>
                        {columns.map((column, index) => (
                          <Draggable
                            key={column.id}
                            draggableId={column.id}
                            index={index}
                          >
                            {(provided) => (
                              <th
                                className={`vendor_tabels ${column.isFiltered ? 'highlighted_column' : ''}`}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                {column.label}
                                {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                                  {/* <SwapVertIcon className="swap-sort-ico" /> */}
                                  {(column.sortLabel != "asc") && <img src={topArrow} />}
                                  {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                  {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                                  {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                                </span>}
                              </th>
                            )}
                          </Draggable>
                        ))}
                      </tr>
                    </thead>
                    <tbody style={{ overflowY: "scroll", width: "200px" }}>
                      {projectCreationlist?.projects.length < 1 && <>
                        <tr>
                          <td colSpan={10} className="text-center list-no-data">No Data Found</td>
                        </tr>
                      </>}
                      {projectCreationlist?.projects.length > 0 && <>
                        {projectCreationlist?.projects?.map((row, rowIndex) => (
                          <tr key={rowIndex} className="maine_tr_vendor">
                            <td>
                              <input type="checkbox" />
                            </td>
                            {columns.map((column, index) => (
                              <td key={index}>
                                {column.id === "projectName" ? (
                                  <Link
                                    className="solutions_block_body"
                                    style={{ textDecoration: "none" }}
                                    to={`/admin/Project-Manager-Detail/${row?._id}`}
                                  >
                                    
                                    <span
                                      className="list-details-para"
                                      onClick={() => redirectToDetails(row?._id)}
                                    >
                               <Tooltip title={row[column.id] || "N/A"}>
                            {trimString(row[column.id], 20 || "N/A")}
                            </Tooltip></span>
                                  </Link>
                                ) : (column.id === "COD" || column.id === "creationDate" || column.id === "updatedAt") ? (
                                  <span
                                    className="solutions_block_body"
                                    style={{ textDecoration: "none" }}
                                  >
                                    {strToDate(row[column.id])}
                                  </span>
                                ) : (
                                  <Tooltip title={row[column.id] || "N/A"}>
                                  {trimString(row[column.id], 20 || "N/A")}
                                  </Tooltip>
                                )}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </>}

                    </tbody>
                  </table>
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          {projectCreationlist?.projects.length > 0 && <>
            <div className="lets_pagination_package_listing_react">
              <div className="pagination_select_react_packagelr_detail">
                <select
                  className="form-select packagelrlisting from-hs"
                  onChange={onPageSizeChange}
                  value={requestPayload?.pageSize}
                >
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span className="react_text_showing">
                  {` Showing rows ${Number(projectCreationlist?.pageSize) * Number(projectCreationlist?.currentPage - 1) + 1} to ${Number(projectCreationlist?.pageSize) * Number(projectCreationlist?.currentPage - 1) + Number(projectCreationlist?.projects.length)} of ${projectCreationlist?.totalItems} `}
                </span>
              </div>

              <Stack spacing={2}>
                <Pagination
                  count={projectCreationlist?.totalPages}
                  page={projectCreationlist?.currentPage}
                  onChange={(event, page) => {
                    setInputPage(page);
                    onPaginationChange(event, page);
                  }}
                  renderItem={(item) => {
                    if (item.page === projectCreationlist?.currentPage) {
                      return (
                        <input
                          className="form-control listing_currentpagination"
                          type="text"
                          value={inputPage}
                          onChange={handleInputChange}
                          onKeyDown={handleInputSubmit}
                        />
                      );
                    }
                    return (
                      <PaginationItem
                        className="pagination_react_listings"
                        slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                      />
                    );
                  }}
                />
              </Stack>
            </div>
          </>}

          {/* ProjectManager Bidding Create Project Modal */}
          <Modal
            open={opencreateprojectslisting}
            onClose={() => handleProjectClose()}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Create Project
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => handleProjectClose()}
                ></button>
              </div>
              <div className="modal-body">
                <form id="projectForm">  
                          {/* <div class="lets_select_sme">
                            <label class="mb-1 text-dark">
                              Project Code <span class="required">*</span>
                            </label>
                            <input
                              type="text"
                              id="projectCode"
                              class="form-control form_h_modal"
                              placeholder=" dd-mm-yyyy"
                            />
                            <div class="error-message" id="projectCodeError"></div>
                          </div> */}
                            <div className="row"> 
                               <div className="col-sm-6">
                                    <label className="mb-1 text-dark"> Project Name <span className="required">*</span>
                                    </label>
                                    <input
                                      type="text" 
                                      id="projectName"
                                      name="projectName"
                                      className="form-control form_h_modal"
                                      placeholder="Enter Project Name"
                                      value={formData.projectName || ''}
                                      onChange={handleChange}
                                      required=""
                                    />
                                    {errors.projectName && <div className="error-message">{errors.projectName}</div>}
                                  </div>    
                           { Array.isArray(activeProjectFields) && activeProjectFields?.map((ele, i) => (
                             <>   
                                {ele.uniqueName === 'location' && ele.display === true && (
                                    <div className="col-sm-6">
                                      <label className="mb-1 text-dark">
                                      {ele.name} {ele?.required && (<span className="required">*</span>)}
                                      </label>
                                      <input
                                        type="text" name={ele.uniqueName}
                                        id={ele.uniqueName}
                                        className="form-control form_h_modal"
                                        placeholder={`Enter ${ele?.name}`}
                                        required=""
                                        key={ele.uniqueName}
                                        value={formData[ele.uniqueName] || ''}
                                        onChange={handleChange}
                                      />
                                      {errors[ele.uniqueName] && (
                                        <div className="error-message">{errors[ele.uniqueName]}</div>
                                      )}
                                    </div>
                                )} 
                                {ele.uniqueName === 'capacity' && ele.display === true &&  ( 
                                    <div className="col-sm-6">
                                      <label className="mb-1 text-dark">
                                      {ele.name} {ele?.required && (<span className="required">*</span>)}
                                      </label>
                                      <input
                                        type="text" name={ele.uniqueName}
                                        id={ele.uniqueName}
                                        className="form-control form_h_modal"
                                        placeholder="Enter Capacity"
                                        value={formData[ele.uniqueName] || ''}
                                        onChange={handleChange}
                                        required=""
                                        key={i} 
                                      />
                                       {errors[ele.uniqueName] && (
                                        <div className="error-message">{errors[ele.uniqueName]}</div>
                                      )}
                                    </div>  
                                )}
                                {ele.uniqueName === 'COD' && ele.display === true && ( 
                                       <div className="col-sm-6">
                                      <label className="mb-1 text-dark">
                                      {ele.name} {ele?.required && (<span className="required">*</span>)}
                                      </label>

                                      <input
                                        type="date" name={ele.uniqueName}
                                        id={ele.uniqueName}
                                        className="form-control form_h_modal"
                                        placeholder="03-03-2024"
                                        value={formData[ele.uniqueName] || ''}
                                        onChange={handleChange}
                                        min={today}
                                        max={maxDateStr}
                                        key={i} 
                                        required=""
                                        pattern="\d{4}-\d{2}-\d{2}"
                                      />

                                      <path d="M6.445 11.688V6.354h-.633A13 13 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23"></path>
                                      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"></path>

                                      {errors[ele.uniqueName] && (
                                        <div className="error-message">{errors[ele.uniqueName]}</div>
                                      )}
                                    </div>
                                    
                                )}

                              {ele.type === "String" && ele?.display === true && ele?.static === false && (                      
                                    <div className="col-sm-6">
                                        <label className="mb-1 text-dark">
                                          {ele?.name}
                                          {ele?.required && (
                                            <span className="required">*</span>
                                          )}
                                        </label>
                                        <input type="text" name={ele.uniqueName}   id={ele.uniqueName}  className="form-control form_h_modal"
                                          placeholder= {`Enter ${ele?.name}`}     required=""
                                          value={formData[ele.uniqueName] || ''}
                                          onChange={handleChange}
                                        />  
                                         {errors[ele.uniqueName] && (
                                        <div className="error-message">{errors[ele.uniqueName]}</div>
                                      )}
                                      </div>  
                                )}

                                {ele.type === "Dropdown" && ele?.display === true && ele?.static === false && (                  
                                    <div className="col-sm-6">
                                        <label className="mb-1 text-dark">
                                          {ele?.name}
                                          {ele?.required && (
                                            <span className="required">*</span>
                                          )}
                                        </label> 
                                              <select
                                                className="form-select w-100 lets_onboarding_wizard_react"
                                                aria-label="Default select example"
                                                fdprocessedid="zlera"
                                                name={ele?.uniqueName}
                                                value={formData[ele.uniqueName] || "null"}  
                                                onChange={handleChange}  
                                                id={ele.uniqueName} 
                                              >
                                                <option value={"null"} >
                                                    Please Select
                                                  </option>
                                              {ele?.options.map((optionEle, i) => (
                                                !optionEle.isDeleted && (
                                                  <>
                                                    <option key={i} value={optionEle?.uniqueName}>
                                                      {optionEle?.optionName}
                                                    </option>
                                                  </>
                                                    )
                                                ))}
                                              </select>{" "} 
                                              {errors[ele.uniqueName] && (
                                                <div className="error-message">{errors[ele.uniqueName]}</div>
                                              )}  
                                      </div>  
                                     
                                )}

                                {ele.type === "Number" && ele?.display === true && ele?.static === false && (                   
                                    <div className="col-sm-6">
                                        <label className="mb-1 text-dark">
                                          {ele?.name}
                                          {ele?.required && (
                                            <span className="required">*</span>
                                          )}
                                        </label>
                                        <input type="number" name={ele.uniqueName}  id={ele.uniqueName}  className="form-control form_h_modal"
                                          placeholder= {`Enter ${ele?.name}`}     required=""
                                          value={formData[ele.uniqueName] || ''}
                                          onChange={handleChange}
                                        />  
                                         {errors[ele.uniqueName] && (
                                        <div className="error-message">{errors[ele.uniqueName]}</div>
                                      )} 
                                      </div>  
                                     
                                )}
                                {ele.type === "Date" && ele?.display === true && ele?.static === false && (                   
                                   <div className="col-sm-6">
                                   <label className="mb-1 text-dark">
                                   {ele.name} {ele?.required && (<span className="required">*</span>)}
                                   </label>

                                   <input
                                     type="date"
                                     id={ele.uniqueName}
                                     key={i} 
                                     className="form-control form_h_modal"
                                     placeholder="03-03-2024"
                                     value={formData[ele.uniqueName] || ''}
                                     onChange={handleChange}
                                     min={today}
                                     max={maxDateStr}
                                     required=""
                                     pattern="\d{4}-\d{2}-\d{2}"
                                   />

                                   <path d="M6.445 11.688V6.354h-.633A13 13 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23"></path>
                                   <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4z"></path>

                                   {errors[ele.uniqueName] && (
                                     <div className="error-message">{errors[ele.uniqueName]}</div>
                                   )}
                                 </div>
                                     
                                )}
                              
                            </>
                           ))} 
                   </div>
                  <div className="clear_btn_status">
                    {/* <button
                      type="button"
                      className="btn clear_btn"
                      data-dismiss="modal"
                      onClick={() => handleProjectClose()}
                    >
                      Close
                    </button> */}
                    <button type="button" className="btn clear_btn" onClick={() => clearProjectFormData()}>Clear</button>
                    <button
                      type="button"
                      className="btn btn-success save_next_btn"
                      // onClick={() => {
                      //   setOpenCreateProjectsListing(false);
                      //   setOpenCreateProjectSuccessfully(true);
                      // }}
                      onClick={handleSubmit}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </Box>
          </Modal>
          {/* ProjectManager Bidding Create Project Successfully Modal */}
          <Modal
            open={opencreateprojectsuccessfully}
            onClose={() => setOpenCreateProjectSuccessfully(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenCreateProjectSuccessfully(false)}
                ></button>
              </div>
              <div className="modal-bodys">
                <from>
                  <div className="approvel_btn_successfully">
                    <img src={checkImage} alt="" />
                    <p>Your Project has been created Successfully</p>
                    <p>
                      Project Code :-
                      <strong className="check_images_project_manager">
                        {projectCode}
                      </strong>
                    </p>
                  </div>
                </from>
              </div>
            </Box>
          </Modal>
          <Modal
              open={openheaderlevelexcelmodal}
              onClose={closeConfirmModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenHeaderLevelExcelModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <p class="project_Manager_bidding">
                    Are you sure you want to download
                    <br /> {confirmObj?.text}
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={downloadProject}
                    >
                      Yes
                    </button>

                    <button
                      href="onboarding_status.html"
                      className="view_lsting"
                      onClick={closeConfirmModal}
                    >
                      No
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>


            <Modal
              open={openheaderlevelsucessfullymodal}
              onClose={() => setOpenHeaderLevelSucessfullyModal(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => setOpenHeaderLevelSucessfullyModal(false)}
                  ></button>
                </div>
                <div class="modal-bodys">
                  <img src={checkImage} alt="" />
                  <p class="project_Manager_bidding">
                  Selected <b>{confirmObj?.text}</b> file has been
                  <br /> downloaded successfully.
                  </p>
                  <div className="all_btn_modal_listing">
                    <button
                      href="onboarding_status.html"
                      className="view_progresse"
                      onClick={() => {
                        setOpenHeaderLevelSucessfullyModal(false);
                      }}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </Box>
            </Modal>
          {showConfirmation && (
            <Modal
              open={showConfirmation}
              onClose={() => setOpenCreateProjectSuccessfully(false)}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={style1} className="modal_react_controlpanel_employees">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    fdprocessedid="kum8iho"
                    onClick={() => handleConfirmationResponse(false)}
                  ></button>
                </div>
                <div className="modal-bodys">
                  <p>You have unsaved changes. Are you sure you want to close?</p>
                  <button className=" btn btn-warning" onClick={() => handleConfirmationResponse(false)}>No</button>
                  <button className="btn btn-success mr-7" onClick={() => handleConfirmationResponse(true)}>Yes</button>
                </div>
              </Box>
            </Modal>



          )}
        </div>
      </div>


      <BulkUploadModal
        createTableArr={createTableArr}
        openBulkUploadModal={openBulkUploadModal}
        setOpenBulkUploadModal={setOpenBulkUploadModal}
        onBulkUploadSubmit={onBulkUploadSubmit}
        onsetOpenDefaulfFields={onsetOpenDefaulfFields}
        openDefaulfFields={openDefaulfFields}
        sampleProjectFile={sampleProjectFile}
        title="Create Project (Upload Excel File)"
      />

      <AlertComponent
        alertComponent={alertComponent}
        handleClose={handleClose}
      />
      <Backdrop
        className="backdrop-index"
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

    </>
  );
}

export default ProjectListing;
